import { render, staticRenderFns } from "./DottedSpacer.vue?vue&type=template&id=21a73862&scoped=true&"
import script from "./DottedSpacer.vue?vue&type=script&lang=ts&"
export * from "./DottedSpacer.vue?vue&type=script&lang=ts&"
import style0 from "./DottedSpacer.vue?vue&type=style&index=0&id=21a73862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a73862",
  null
  
)

export default component.exports